module.exports = __webpack_public_path__ + "static/homepage-364384d84848dcc809d97fed7596fcb8.png";